<template>
  <div class="PPage__inner"><slot></slot></div>
</template>

<script>
export default {
  name: "PageInner"
};
</script>
